'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '../button';
import { AlertDialog } from '../custom/alert-dialog';

interface OrganisationSwitchWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  /** Human-readable target view (company / role), shown in title and body. */
  viewName: string;
  isConfirming?: boolean;
}

export function OrganisationSwitchWarningDialog({
  open,
  onOpenChange,
  onConfirm,
  viewName,
  isConfirming = false,
}: OrganisationSwitchWarningDialogProps) {
  const displayViewName = viewName.trim() || 'this view';

  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="warning"
      title={`Switch to ${displayViewName}?`}
      description={`This will switch all your open Native Teams tabs to ${displayViewName}. Anything you haven't saved, like a form or payment in progress, will be lost.`}
    >
      <Button
        type="button"
        variant="secondary"
        className="w-full"
        isLoading={isConfirming}
        loadingText="Loading"
        onClick={onConfirm}
      >
        Switch view
      </Button>
      <Button
        type="button"
        variant="secondary"
        className="w-full"
        disabled={isConfirming}
        onClick={() => onOpenChange(false)}
      >
        Cancel
      </Button>
    </AlertDialog>
  );
}
